import { Box, Button, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useChangeEmail } from "../../../api/users";
import styles from "./changeEmailProfile.module.css";


interface ChangeEmailProfileProps {
  onSuccess?: () => void;
}


export const ChangeEmailProfile = ({ onSuccess }: ChangeEmailProfileProps) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const { changeEmailMutation, changeEmailPincodeMutation, error } = useChangeEmail();
  const [successEmailChange, setSuccessEmailChange] = useState(false);
  const [pinCode, setPinCode] = useState("");

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setEmail(value);
  };
  const handleEmailChangeSubmit = async () => {
    const { success } = await changeEmailMutation({ email });
    if (success) {
      setSuccessEmailChange(true);
    }
  };

  const handlePinCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setPinCode(value);
  };

  const handleEmailChangePincodeSubmit = async () => {
    const { success } = await changeEmailPincodeMutation({ pin_code: pinCode });
    if (success) {
      window.dispatchEvent(new Event("profileUpdated"));
      onSuccess?.();
    }
  };

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
      {successEmailChange ? (
        <>
          <Box sx={{ width: "100%" }}>
            <TextField
              name="pincode"
              label={t("Pin code")}
              size="small"
              fullWidth
              value={pinCode}
              onChange={handlePinCodeChange}
              required
            />
            {error && (
              <div className={styles.errorMessage}>{error?.[0]?.message}</div>
            )}
          </Box>
          <Box sx={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              color="success"
              onClick={handleEmailChangePincodeSubmit}
            >
              {t("Confirm email change")}
            </Button>
          </Box>
        </>
      ) : (
        <>
          <Box sx={{ width: "100%" }}>
            <TextField
              name="email"
              label={t("Email address")}
              size="small"
              fullWidth
              value={email}
              onChange={handleEmailChange}
              required
            />
            {error && error?.email && (
              <div className={styles.errorMessage}>{error.email[0]?.message}</div>
            )}
          </Box>
          <Box sx={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              color="success"
              onClick={handleEmailChangeSubmit}
            >
              {t("Send pin code")}
            </Button>
          </Box>
        </>
      )}
    </Box>
  )
}
